import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import ISubscription from "Types/Subscription";
import { State } from "store/reducers";
import ls from "Localization";

export const CREATE_SUBSCRIPTION = "[SUBSCRIPTION CREATE] CREATE_SUBSCRIPTION";
export const CREATE_SUBSCRIPTION_SUCCESS =
	"[SUBSCRIPTION CREATE] CREATE_SUBSCRIPTION_SUCCESS";
export const CREATE_SUBSCRIPTION_FAILED =
	"[SUBSCRIPTION CREATE] CREATE_SUBSCRIPTION_FAILED";

export const SET_VALUE = "[SUBSCRIPTION CREATE] SET_VALUE";
export const CLEAR_VALUES = "[SUBSCRIPTION CREATE] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function createSubscription(callback: Callback<ISubscription>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CREATE_SUBSCRIPTION });

		try {
			const { login, subscriptionCreate } = getState() as State;

			const {
				user,
				value,
				discount,
				installment,
				installmentInterval,
				description,
				status,
				plan,
				paymentMethod,
				firstPayment
			}: any = subscriptionCreate;

			const errors: any = {};

			if (!user) errors.user = ls.required;
			if (!value) errors.value = ls.required;
			if (!installment) errors.installment = ls.required;
			if (!plan) errors.plan = ls.required;
			if (!paymentMethod) errors.paymentMethod = ls.required;
			if (!firstPayment) errors.firstPayment = ls.required;

			dispatch(setValue({ errors }));

			if (Object.keys(errors).length)
				return dispatch({ type: SET_VALUE, payload: { loading: false } });

			const model = {
				user,
				value: Math.round(+value * 100),
				discount: Math.round(+discount * 100),
				installment,
				installmentInterval,
				description,
				status,
				plan,
				paymentMethod,
				firstPayment
			};

			const response = await api.sendPost("/Subscription", model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: CREATE_SUBSCRIPTION_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: CREATE_SUBSCRIPTION_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: CREATE_SUBSCRIPTION_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
